var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoMetropolisSymbol(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_738_2045)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9344 32.4638L26.3291 12.0449L29.3694 23.9574H39.4944C40.9709 17.7999 39.1685 11.3426 34.6793 6.7069C30.1901 2.07118 23.5944 -0.14375 17.0588 0.789718L21.9344 32.4638Z",
    fill: "url(#paint0_linear_738_2045)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.869 23.7681L15.8824 0.579712C5.28045 2.64215 -1.67049 13.0186 0.348964 23.7681H10.869Z",
    fill: "url(#paint1_linear_738_2045)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.21 25.5101L26.5402 19.7101L22.353 39.4203C30.0368 38.6058 37.0588 32.4638 38.8236 25.5072L28.21 25.5101Z",
    fill: "#F3921E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2705 7.53624L12.1711 25.3856H0.588257C2.95809 33.6634 10.8333 39.4088 19.8258 39.4203C20.2823 39.4203 20.7298 39.4007 21.1765 39.3724L16.2705 7.53624Z",
    fill: "#F3921E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_738_2045",
    x1: 28.5315,
    y1: 0.384828,
    x2: 28.5315,
    y2: 37.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.018,
    stopColor: "#FFEA21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.102,
    stopColor: "#FED70F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#FDCC04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#FDC800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746,
    stopColor: "#F18F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E95F32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_738_2045",
    x1: 7.94297,
    y1: 0.0143998,
    x2: 7.94297,
    y2: 38.2245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.018,
    stopColor: "#FFEA21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.102,
    stopColor: "#FED70F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.189,
    stopColor: "#FDCC04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#FDC800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746,
    stopColor: "#F18F34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E95F32"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_738_2045"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMetropolisSymbol);
export default __webpack_public_path__ + "static/media/logo-metropolis-symbol.18cf8ae90a123faba4fe504ac9a68d48.svg";
export { ForwardRef as ReactComponent };